import { useMemo } from 'modules/core/hooks/useMemo'

import type Contract from 'modules/contracts/lib/Contract'
import calculateContracts from 'modules/contracts/lib/calculateContracts'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'

interface EmployeeContracts {
  contracts: Contract[]
  selectedContract?: Contract
  nextContract?: Contract
  previousContract?: Contract
}

const useContracts = (
  selectedContractVersion: ContractVersion,
  sortedContractVersions: ContractVersion[]
): EmployeeContracts => {
  const contractsKey = sortedContractVersions.map((version) => version.startsOn?.unix()).join()
  const contracts = useMemo(() => {
    return calculateContracts(sortedContractVersions)
  }, [contractsKey]) // eslint-disable-line react-hooks/exhaustive-deps
  const selectedContractIndex = contracts.findIndex((contract) =>
    contract.includesVersion(selectedContractVersion)
  )
  const selectedContract = contracts[selectedContractIndex]
  const nextContract = contracts[selectedContractIndex - 1]
  const previousContract = contracts[selectedContractIndex + 1]

  return {
    contracts,
    selectedContract,
    nextContract,
    previousContract,
  }
}

export default useContracts
